import { useContext } from "react";
import NotificationIcon from "../../../Dashboard/FullPages/Notifications/NotificationIcon/NotificationIcon";
import RenderSubMenu from "./renderSubMenu";
import { EventsStateContext } from "../../../../../context/EventsProvider";
import Svg, {SvgEnum} from "../../../../ui library/components/svgs/standard/svg";

export default function RenderActionButtons() {
  const actionButtonList = [];
  const globalEventDispatch = useContext(EventsStateContext);

  actionButtonList.push({
    link: "/notifications",
    content: globalEventDispatch.notifications.count,
    icon: <Svg name={SvgEnum.HisNotification}/>,
  });

  actionButtonList.push({
    icon: (
      <Svg name={SvgEnum.HisAvatar} />
    ),
    subMenuList: RenderSubMenu,
  });

  return actionButtonList;
}
